import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-archive-pet-modal',
  templateUrl: './archive-pet-modal.component.html',
  styleUrls: ['./archive-pet-modal.component.scss']
})
export class ArchivePetModalComponent implements OnInit {
  @Input() petName: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
